import { GET } from './HTTP';
import {Image} from "@/models/ImageModel";

export function getImage(id: string): Promise<Image>{
    return GET('/images/' + id);
}
 